export const environment = {
    hmr: false,
    production: false,
    newWorkMaxSingleFileSizeMB: 300,
    newWorkMaxMultiFileSizeMB: 30,
    newWorkMaxMultiFileCount: 5,
};
